import { InputForm } from '@/components/new/form/InputForm'
import { TextAreaForm } from '@/components/new'
import { useModalWizardStepsContext } from '@/components/new/modalWizardSteps/ModalWizardStepsContext'
import { AsyncSelectForm } from '@/components/forms/AsyncSelectForm'
import { getCountries } from '@/api/countriesAPI'
import { getContainerCategories } from '@/api/containerCategoriesAPI'
import useContainerWizzardSteps from '@/state/useContainerWizzardSteps'
import { useEffect } from 'react'
import { SelectFormOriginDestiny } from '../../../components/SelectFormOriginDestiny'

export default function DetailsGeneralContainerTab() {
  const { useFormWizzard } = useModalWizardStepsContext()
  const { control, watch, getValues, reset } = useFormWizzard
  const updateData = useContainerWizzardSteps((state) => state.updateData)
  const storeData = useContainerWizzardSteps((state) => state.data)

  // Resetear el formulario cuando el store se resetea
  useEffect(() => {
    const isEmptyStore =
      storeData.name === '' &&
      storeData.originId === 0 &&
      storeData.destinyId === 0 &&
      storeData.categories.length === 0

    if (isEmptyStore) {
      // Usar setTimeout para asegurar que el reset se ejecute después del render
      setTimeout(() => {
        reset({
          name: '',
          originId: null,
          countryFromId: null,
          destinyId: null,
          categories: [],
          levanteNumber: '',
          trackingNumber: '',
          observations: '',
        })
      }, 50)
    }
  }, [storeData, reset])

  // Sincroniza los valores del formulario con el store global
  useEffect(() => {
    const subscription = watch(() => {
      updateData({
        ...useContainerWizzardSteps.getState().data,
        ...getValues(),
      })
    })
    return () => subscription.unsubscribe()
  }, [watch, getValues, updateData])

  // Async fetchers
  const fetchCountries = async (search: string) => {
    const response = await getCountries()
    if (!Array.isArray(response)) return []
    return response
      .filter((item) => item.name.toLowerCase().includes(search.toLowerCase()))
      .map(({ id, name }) => ({ id: id, label: name })) // Keep id as number
  }
  const fetchCategories = async (search: string) => {
    const response = await getContainerCategories()
    if (!Array.isArray(response)) return []
    return response
      .filter((item) => item.name.toLowerCase().includes(search.toLowerCase()))
      .map(({ id, name }) => ({ id: id, label: name })) // Keep id as number
  }

  return (
    <div className={'h-[60dvh] overflow-y-auto'}>
      <div className={'space-y-5 py-4'}>
        <InputForm
          control={control}
          label="Nombre"
          name="name"
          placeholder="Nombre del contenedor"
          rules={{ required: 'Campo requerido' }}
        />
        <SelectFormOriginDestiny
          control={control}
          label="Origen"
          name="originId"
          notFoundMessage="No se encontraron orígenes."
          placeholder="Buscar origen..."
        />
        <AsyncSelectForm
          control={control}
          fetcher={fetchCountries}
          label="País de origen"
          name="countryFromId"
          notFoundMessage="No se encontraron países."
          placeholder="Buscar país..."
        />
        <SelectFormOriginDestiny
          control={control}
          label="Destino"
          name="destinyId"
          notFoundMessage="No se encontraron destinos."
          placeholder="Buscar destino..."
        />
        <AsyncSelectForm
          control={control}
          fetcher={fetchCategories}
          label="Categorías"
          multiple={true}
          name="categories"
          notFoundMessage="No se encontraron categorías."
          placeholder="Buscar categorías..."
        />
        <InputForm
          control={control}
          label="Número de levante"
          name="levanteNumber"
          placeholder="Número de levante"
        />
        <InputForm
          control={control}
          label="Número de tracking"
          name="trackingNumber"
          placeholder="Número de tracking"
        />
        <TextAreaForm
          control={control}
          label="Observaciones"
          name="observations"
          placeholder="Observaciones"
        />
      </div>
    </div>
  )
}
